import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UtensilsCrossed, ClipboardList, UserCircle2, ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext.jsx";

const tabs = [
    { icon: UtensilsCrossed, label: "Меню",    path: "/"        },
    { icon: ClipboardList,   label: "Заказы",  path: "/history" },
    { icon: UserCircle2,     label: "Профиль", path: "/profile" },
];

const BottomNav = () => {
    const navigate  = useNavigate();
    const { pathname } = useLocation();
    const { totalItems, totalPrice } = useCart();
    const hasCart = totalItems > 0;

    const { search } = useLocation();

    const go = (path) => navigate({ pathname: path, search });

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-1px_8px_rgba(0,0,0,0.06)]">
            {hasCart && (
                <div
                    className="px-4 py-3 border-b border-gray-100 cursor-pointer active:bg-gray-50 transition-colors cart-bar-enter"
                    onClick={() => go("/cart")}
                >
                    <div className="max-w-screen-md mx-auto flex items-center justify-between gap-3">
                        <div className="flex items-baseline gap-2 min-w-0">
                            <span className="text-xs text-gray-500 shrink-0">
                                {totalItems} {totalItems === 1 ? 'позиция' : totalItems < 5 ? 'позиции' : 'позиций'}
                            </span>
                            <span className="text-base font-bold text-gray-900">{totalPrice} ₽</span>
                        </div>
                        <button className="shrink-0 bg-brandBlue text-white text-sm font-semibold px-5 py-2 rounded-xl flex items-center gap-2 hover:bg-brandBlue/90 active:scale-95 transition-all shadow-md shadow-brandBlue/20">
                            <ShoppingCart size={15} />
                            Корзина
                        </button>
                    </div>
                </div>
            )}

            <div className="max-w-screen-md mx-auto flex h-16">
                {tabs.map(({ icon: Icon, label, path }) => {
                    const active = pathname === path;
                    return (
                        <button
                            key={path}
                            onClick={() => go(path)}
                            className="flex-1 flex flex-col items-center justify-center gap-1 transition-colors"
                        >
                            <Icon
                                size={22}
                                className={active ? "text-blue-600" : "text-gray-400"}
                                strokeWidth={active ? 2.5 : 1.5}
                            />
                            <span className={`text-[11px] font-medium leading-none ${active ? "text-blue-600" : "text-gray-400"}`}>
                                {label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
